import { createFileRoute, Link } from "@tanstack/react-router";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { QUESTIONS } from "@/data/questions";
import { HelpCircle, ArrowRight } from "lucide-react";

export const Route = createFileRoute("/questions/")({
  head: () => ({
    meta: [
      { title: "Contract Questions, Answered — Plain-English Guides" },
      {
        name: "description",
        content:
          "Common contract questions answered in plain English: what to look for in a lease, is this NDA normal, how to read a contract, contract red flags, and more.",
      },
      { property: "og:title", content: "Contract Questions, Answered — legaldecoder" },
      {
        property: "og:description",
        content:
          "Plain-English answers to the most-asked contract questions — leases, NDAs, freelance, employment.",
      },
      { property: "og:url", content: "https://legaldecoder.io/questions" },
    ],
    links: [{ rel: "canonical", href: "https://legaldecoder.io/questions" }],
  }),
  component: QuestionsIndex,
});

function QuestionsIndex() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <section className="relative overflow-hidden border-b border-border">
          <div className="absolute inset-0 bg-gradient-glow" aria-hidden />
          <div className="relative mx-auto max-w-5xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
            <div className="inline-flex items-center gap-2 rounded-full border border-border bg-card/60 px-3 py-1 text-xs font-medium text-muted-foreground">
              <HelpCircle className="h-3.5 w-3.5" /> Questions, answered
            </div>
            <h1 className="mt-4 text-4xl font-bold tracking-tight sm:text-5xl">
              Contract Questions, Answered in Plain English
            </h1>
            <p className="mt-3 max-w-2xl text-lg text-muted-foreground">
              The questions people actually search before signing — leases, NDAs, freelance,
              employment. No legalese, no fluff.
            </p>
          </div>
        </section>

        <section className="py-12 sm:py-16">
          <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
            <ul className="grid gap-4 sm:grid-cols-2">
              {QUESTIONS.map((q) => (
                <li key={q.slug}>
                  <Link
                    to="/questions/$slug"
                    params={{ slug: q.slug }}
                    className="group block rounded-2xl border border-border bg-card p-5 shadow-card transition hover:border-primary-glow/40 hover:shadow-card-hover"
                  >
                    <h2 className="text-base font-semibold group-hover:text-primary-glow">
                      {q.title}
                    </h2>
                    <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{q.intro}</p>
                    <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-primary-glow">
                      Read answer <ArrowRight className="h-3.5 w-3.5" />
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </section>
        <Footer />
      </main>
    </div>
  );
}
